import { inject } from '@angular/core';
import { map } from 'rxjs';
import { ApiEndpointsPaths } from '../../utils/api-endpoints.service';
import { ApiHttpService } from '../../utils/api-http.service';
import {
  IUserPreferencesNotifications,
  MailingService,
} from './mailing-service.interface';

const ALLOW_FALLBACK_LOCATION_KEY = 'location-force-shared';
const MAX_TIME_TO_WAIT_FOR_LOCATION = 15000;

/**
 * Implementation of the BrowserService interface.
 */
export class MailingServiceImpl implements MailingService {
  #httpClient: ApiHttpService = inject(ApiHttpService);
  #endpointsPaths = inject(ApiEndpointsPaths);

  /**
   * Returns the current permission state of the specified browser permission.
   *
   * @param options An object containing the name of the permission to check.
   * @returns A Promise that resolves with the current state of the permission.
   * @throws An error if the browser does not support the Permissions API.
   */
  get(data: { email: string; token: string }) {
    return this.#httpClient
      .get<IUserPreferencesNotifications>(
        this.#endpointsPaths.resolve(
          this.#endpointsPaths.endpoints.fetchUserNotificationsPreferences,
        ),
        {
          params: {
            email: data.email,
            key: data.token,
          },
        },
      )
      .pipe(map((response) => response));
  }

  /**
   * Returns the current permission state of the specified browser permission.
   *
   * @param permission An object containing the name of the permission to check.
   * @throws An error if the browser does not support the Permissions API.
   */
  setUserNotificationsPreferences(payload: {
    email: string;
    key: string;
    notifications: IUserPreferencesNotifications;
  }) {
    return this.#httpClient
      .put<IUserPreferencesNotifications>(
        this.#endpointsPaths.resolve(
          this.#endpointsPaths.endpoints.updateUserNotificationsPreferences,
        ),
        payload,
      )
      .pipe(map((response) => response));
  }
}
